import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import HubspotForm from "react-hubspot-form";

const Switch = () => {
  const navigate = useNavigate();
  const [details, setDetails] = useState({
    email: "",
    mobile: "",
    name: "",
    check: "",
  });


  const [cap1, setCap1] = useState("");
  const [cap2, setCap2] = useState("");
  const [setMess] = useState("");
  // const [mess, setMess] = useState("");

  useEffect(() => {
    const otp = Math.floor(1 + Math.random() * 9);
    const otp2 = Math.floor(1 + Math.random() * 9);
    setCap1(otp);
    setCap2(otp2);
  }, []);

  const total = cap1 + cap2;

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setDetails((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleFormSUbmit = async (e) => {
    e.preventDefault();
    if (details.check === total) {
      setMess("processing...");
      await axios
        .post("https://landing.premisin.com/reactSubmit.php", {
          name: details.name,
          email: details.email,
          mobile: details.mobile,
          action: "side",
        })
        .then((response) => {
          setMess(response.data.message);
          if (response.data.status === 1) {
            setDetails({ name: "", email: "", mobile: "" });
            navigate("/thankyou");
            setMess(response.data.message);
            window.gtag("event", "conversion", {
              send_to: "AW-10896336864/HC9qCKTrsLoDEODP48so",
              // event_callback: callback,
            });
          }
        })
        .catch((error) => {
          console.log(error);
          setMess("Something went wrong");
        });
    } else {
      setMess("Please Enter Correct Addition.");
    }
  };
  return (
    <>
      <section id="switch" className="startup-team">
        <div className="container">
          <div className="row text-center">
            <div className="col-lg-12 mx-auto">
              <h2 className="h1" style={{ color: "#fff" }}>
                Switch to Premisin
              </h2>
              <div className="u-h-4 u-w-50 bg-white rounded mt-4 u-mb-50 mx-auto"></div>
              {/* <!--<h3>Premisin - A Fully Furnished Dedicated and Co Working Office Space Provider in Raipur.</h3>--> */}
              <p style={{ color: "#fff" }}>
                Moving to Premisin means embracing a dynamic work environment
                that aligns with your aspirations. Join a community of
                like-minded professionals who are dedicated to making a positive
                impact.
              </p>

              <p style={{ color: "#fff" }}>
                Schedule your free visit now and witness the transformation that
                awaits you at Premisin. Elevate your work, elevate your success.
                Take the first step today!
              </p>

              <div className="text-center mx-auto mb-5">
                <button
                  className="btn btn btn-rounded btn-primary mt-5"
                  style={{ backgroundColor: "#fff", color: "#0081FF" }}
                  onClick={() =>
                    window.gtag(
                      "event",
                      "button_click_swi_to_pre_schedule_office_visit"
                    )
                  }
                  data-toggle="modal"
                  data-target="#sidenavmail"
                >
                  Schedule a office space visit
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>

      <div
        className="modal fade"
        id="sidenavmail"
        data-backdrop="static"
        data-keyboard="false"
        tabindex="-1"
        aria-labelledby="staticBackdropLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable">
          <div className="modal-content">
            <div className="modal-header">
              <h3 className="modal-title">Get Your Office Quote Now!</h3>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <div className="p-3 u-of-hidden">
                <div style={{ marginBottom: '-105px' }}>
                  <HubspotForm
                    portalId='7848680'
                    formId='cf71a51e-2ec0-4e62-a181-7c1ef898b72b'
                    onSubmit={() => console.log('Submit!')}
                    onReady={(form) => console.log('Form ready!')}
                    loading={<div>Loading...</div>}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Switch;
